



















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class SchemeRaisingProcess extends Vue {
  @Prop({ type: Number, default: 0 }) surplus!: number;

  @Prop({ type: Number, default: 0 }) total!: number;

  get meta() {
    const { surplus, total } = this;
    const percent = total === 0 ? 0 : (total - surplus) / total;
    const percentText = this.$common.utils.number.toPercent(percent, false);
    return {
      total,
      percentText,
      percent: percent * 100,
      saled: (total - surplus).toFixed(8)
    };
  }
}
export default SchemeRaisingProcess;
